import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getPatientCAAMetricsWeekQueryKey(
  patientId: string,
  { personaName, date }: { personaName?: string; date: string }
) {
  return ['patientCAAMetricsWeek', patientId, { personaName, date }]
}

export function usePatientCAAMetricsWeekQuery({
  patientId,
  personaName,
  date,
  enabled
}: {
  patientId: string
  personaName?: string
  date: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getPatientCAAMetricsWeekQueryKey(patientId, {
      personaName,
      date
    }),
    queryFn: async () =>
      await caaMetricsInstance.getPatientCAAMetricsWeek({
        patientId,
        personaName,
        date
      }),
    enabled
  })
}
